// extracted by mini-css-extract-plugin
module.exports = {"item":"MenuLink_item__1YHK-"};